/** Log categories for different cases */
enum LogCategories {
  auth = "auth"
}
export default LogCategories;
